
export default class InventoryModel {
    constructor ( 
        _customerName = "",
		_comments =     "",
        _tracking =     "",
		_phone =        "",
		_weight =       "",
		_photo =        "",
		_product =      {
			code:985,
			description:"SIN DEFINIR",
			name:"SIN DEFIINIR",
		}, 
		_customer=      {id: 0, name: "SIN DEFINIR"},
		_provider=      '',
		_inv02Code =    '',
		_customerfound = 0,

    ){
      
        this.customerName = _customerName,
		this.comments     = _comments,
        this.tracking     = _tracking,
		this.phone        = _phone,
		this.weight       = _weight,
		this.photo        = _photo,
		this.product      = _product,
		this.customer    = _customer,
		this.provider    = _provider,
		this.inv02Code    = _inv02Code,
		this.customerfound = _customerfound
   }
  
  }  
  
  